<template>
  <base-container>
    <view class="btn-item">
      <cube-basic-picker />
    </view>

    <view class="btn-item">
      <cube-wx-model-picker />
    </view>

    <view class="btn-item">
      <cube-slot-picker />
    </view>

    <view class="btn-item">
      <cube-update-data-picker />
    </view>
  </base-container>
</template>

<script>
import { createPage } from '@mpxjs/core'

createPage({})
</script>

<style lang="stylus">
.btn-item
  margin-bottom 15px
</style>

<script type="application/json">
  {
    "usingComponents": {
      "base-container": "../../components/base-container/index",
      "cube-divider": "@mpxjs/mpx-cube-ui/src/components/divider/index",
      "cube-basic-picker": "./basic-picker",
      "cube-wx-model-picker": "./wx-model-picker",
      "cube-slot-picker": "./slot-picker",
      "cube-update-data-picker": "./update-data-picker"
    }
  }
</script>
